import { convertToDateSlash, formatDBDate, CLIENT_DATE_TIME_NO_SECONDS, DATETIME_DB_FORMAT } from '@/utils/date'
import { unMaskPrice } from '@/utils/common'

export const mapWarrantyRepairToPayload = (raw = {}) => {
  const item = {
    ...(raw.id ? { id: raw.id } : {}),
    primaryTechnicianId: raw.primaryTechnicianId,
    supportTechnician1Id: raw.supportTechnician1Id,
    supportTechnician2Id: raw.supportTechnician2Id,
    startAt: formatDBDate(raw.startAt, CLIENT_DATE_TIME_NO_SECONDS, DATETIME_DB_FORMAT),
    estimatedCompletionAt: formatDBDate(
      raw.estimatedCompletionAt,
      CLIENT_DATE_TIME_NO_SECONDS,
      DATETIME_DB_FORMAT,
    ),
    actualCompletionAt: formatDBDate(
      raw.actualCompletionAt,
      CLIENT_DATE_TIME_NO_SECONDS,
      DATETIME_DB_FORMAT,
    ),
    solutionId: raw.solutionId,
    repairCost: unMaskPrice(raw.repairCost || 0),
    errorGroupId: raw.errorGroupId,
    technicalErrorId: raw.technicalErrorId,
    technicalErrorIds:
      raw.technicalErrors?.length > 0 ? raw.technicalErrors.map((opt) => String(opt.id)).join(',') : null,
    repairSolution: raw.repairSolution,
    repairMethod: raw.repairMethod,
    errorSeverityId: raw.errorSeverityId,
    isCannotRepair: raw.isCannotRepair,
    isDisagreePrice: raw.isDisagreePrice,
    newProductId: raw.newProductId,
    newImeiId: raw.newImeiId,
    newImeiCode: raw.newImeiCode || null,
  }

  const meaningfulKeys = [
    'errorSeverityId',
    'errorGroupId',
    'technicalErrorIds',
    'primaryTechnicianId',
    'supportTechnician1Id',
    'supportTechnician2Id',
    'startAt',
    'estimatedCompletionAt',
    'actualCompletionAt',
    'solutionId',
    'repairSolution',
    'repairMethod',
    'repairCost',
    'isCannotRepair',
    'isDisagreePrice',
    'newProductId',
    'newImeiId',
    'newImeiCode',
  ]
  const hasMeaningfulValue = meaningfulKeys.some((k) => {
    const v = item[k]
    if (typeof v === 'boolean') return v === true
    return v != null && v !== ''
  })

  if (!raw.id && !hasMeaningfulValue) return null
  return item
}

export const buildWarrantyRepairsPayload = (warrantyRepairs = []) => {
  const out = []
  for (const raw of warrantyRepairs || []) {
    const item = mapWarrantyRepairToPayload(raw)
    if (item) out.push(item)
  }
  return out
}

export const normalizeWarrantyRepairFromApi = (repair = {}) => {
  return {
    id: repair.id,
    primaryTechnicianId: repair.primaryTechnicianId,
    primaryTechnicianName: repair.primaryTechnicianName || '',
    supportTechnician1Id: repair.supportTechnician1Id,
    supportTechnician1Name: repair.supportTechnician1Name || '',
    supportTechnician2Id: repair.supportTechnician2Id,
    supportTechnician2Name: repair.supportTechnician2Name || '',
    startAt: convertToDateSlash(repair.startAt),
    estimatedCompletionAt: convertToDateSlash(repair.estimatedCompletionAt),
    actualCompletionAt: convertToDateSlash(repair.actualCompletionAt),
    solutionId: repair.solutionId,
    repairCost: repair.repairCost ?? null,
    repairSolution: repair.repairSolution || '',
    repairMethod: repair.repairMethod || '',
    errorGroupId: repair.errorGroupId,
    technicalErrorId: repair.technicalErrorId || null,
    technicalErrorIds: repair.technicalErrorIds || null,
    technicalErrors: repair.technicalErrors || [],
    errorSeverityId: repair.errorSeverityId,
    isCannotRepair: repair.isCannotRepair,
    isDisagreePrice: repair.isDisagreePrice,
    newProductId: repair.newProductId || null,
    newImeiId: repair.newImeiId || null,
    newProductName: repair.newProductName || null,
    newProductPrice: repair.newProductPrice != null ? repair.newProductPrice : null,
    newImeiCode: repair.newImeiCode || null,
  }
}

